import {
  Navbar as MuiNavbar,
  Typography,
  Avatar,
} from "@material-tailwind/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

import { FC } from "react";

export type NavbarProps = {
  name: string;
  isMenuOpen: boolean;
  onMenuClick: () => void;
};

const Navbar: FC<NavbarProps> = ({ name, isMenuOpen, onMenuClick }) => {
  return (
    <MuiNavbar className="fixed inset-x-0 top-0 z-[100] h-16 max-w-full rounded-none border-0 bg-blue-gray-900 px-4 py-0 shadow-lg shadow-blue-gray-900/10 lg:px-8">
      <div className="mx-auto flex h-full w-full max-w-[1600px] items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3">
          <button
            type="button"
            className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-xl text-blue-gray-200 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-300 lg:hidden"
            aria-label={
              isMenuOpen ? "Close navigation menu" : "Open navigation menu"
            }
            aria-controls="primary-navigation"
            aria-expanded={isMenuOpen}
            onClick={onMenuClick}
          >
            {isMenuOpen ? (
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            ) : (
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            )}
            <span className="sr-only">
              {isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            </span>
          </button>

          <Typography
            variant="h5"
            className="flex min-w-0 items-center gap-2 text-base font-semibold tracking-tight text-white sm:text-lg"
          >
            <img
              src="/logo192.png"
              className="h-8 w-8 shrink-0 rounded-lg object-contain"
              alt=""
              height={32}
              width={32}
            />
            <span className="truncate">Sportbook Backoffice</span>
          </Typography>
        </div>

        <div className="flex min-w-0 shrink-0 items-center gap-2 sm:gap-3">
          <Avatar
            src={`https://ui-avatars.com/api/?background=065c15&color=fff&name=${name}`}
            size="sm"
            alt={`Profile avatar for ${name}`}
          />
          <Typography
            variant="h6"
            className="max-w-[7rem] truncate text-sm font-medium text-blue-gray-100 sm:max-w-[14rem] sm:text-base"
            title={name}
          >
            {name}
          </Typography>
        </div>
      </div>
    </MuiNavbar>
  );
};

export default Navbar;
